export default "__VITE_ASSET__u2YPQhYu__"